import { render, staticRenderFns } from "./ContratoDetalhar2.vue?vue&type=template&id=224f1cfc"
import script from "./ContratoDetalhar2.vue?vue&type=script&lang=js"
export * from "./ContratoDetalhar2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports